export default "__VITE_ASSET__cb729746__"